export const initialState = {
    notifications: [],
    queue: [],
    lastTimestamp: null,
};
